import { ArticleHeading3, ArticleParagraph2, Button } from '@cian/ui-kit';
import * as React from 'react';

import img from './assets/img.svg';
import * as styles from './styles.css';

interface ICPDTrapProps {
  onClick?: () => void;
}

export const CPDBannerTrap: React.FC<ICPDTrapProps> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <ArticleHeading3 color="black_100">Доверьте поиск жилья профессионалу</ArticleHeading3>
          <ArticleParagraph2 color="gray60_100">
            Погрузимся в задачу, изучим ваши пожелания и подберём дом мечты
          </ArticleParagraph2>
        </div>

        <Button theme="fill_primary" size="M" onClick={onClick}>
          Нужен профи
        </Button>
      </div>

      <div className={styles['image']}>
        <img src={img} />
      </div>
    </div>
  );
};
